module.exports = __webpack_public_path__ + "static/media/Robert-Craescu-Headshot.18e1a050.png";